import { Button, makeStyles, Paper, Typography } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import { isUndefined } from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useApi from 'src/hooks/useApi';
import ApiService from 'src/modules/api-service';

import { BidDataTablesOutputListBidDTO, DetailCarDTO } from '../modules/generated/api';

import BoughtCarDeliveryAddressTransportation from './BoughtCarDeliveryAddressTransportation';

const useStyles = makeStyles((theme) => ({
  tiles: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(2),
  },
  center: {
    textAlign: 'center',
  },
}));

type CarDetailBoughtCarDeliveryAddressProps = {
  car: DetailCarDTO;
};
const CarDetailBoughtCarDeliveryAddress = ({ car }: CarDetailBoughtCarDeliveryAddressProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { fetch } = useApi<BidDataTablesOutputListBidDTO>();

  const [bid, setBid] = useState(car.bid);

  const handleSearchBid = async () => {
    if (isUndefined(car.vin)) return;
    const response = await fetch(
      ApiService.bids.bidControllerList1({
        carsRequest: { carIds: [car.vin] },
      }),
    );
    const queriedBid = response?.data?.data?.[0];
    if (queriedBid) setBid(queriedBid);
  };

  useEffect(() => {
    setBid(car.bid);
  }, [car]);

  return (
    <Paper elevation={3} className={classes.tiles}>
      {bid?.id && (
        <div>
          <BoughtCarDeliveryAddressTransportation
            deliveryAddressSelection={car.deliveryAddressSelection}
            bidId={bid.id}
            vin={car.vin}
            source={car.source}
          />
        </div>
      )}
      {!bid && (
        <div>
          <Typography variant="h2">{t('navigation.delivery')} </Typography>
          <p>{t('alerts.loadDeliveryAddress')}</p>
          <div className={classes.center}>
            <Button onClick={handleSearchBid}>
              <Refresh /> {t('common.loadMore')}
            </Button>
          </div>
        </div>
      )}
    </Paper>
  );
};

export default CarDetailBoughtCarDeliveryAddress;
